export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9811.fe2242a6.jpg";